import { Card, Col, Row, Skeleton } from '@repo/ui/components'

export const QuickKycLoading = () => {
  return (
    <div className='px-md'>
      <Card className='p-xl rounded-sm'>
        <Col className='gap-4xl'>
          <Row className='justify-between gap-md'>
            <Skeleton className='h-6 w-40' />
            <Skeleton className='h-4 w-10' />
          </Row>

          <Row className='justify-between gap-md'>
            <Skeleton className='h-12 w-32' />
            <Skeleton className='h-12 w-32' />
            <Skeleton className='h-12 w-32' />
          </Row>

          {/* Form fields skeleton */}
          <Col className='gap-4xl'>
            {/* Mobile/Email field */}
            <Col className='gap-xs'>
              <Skeleton className='h-4 w-20' />
              <Skeleton className='h-12 w-full' />
            </Col>
            <Skeleton className='h-3 w-40 -mt-xs' />

            {/* Submit button */}
            <Skeleton className='h-12 w-full' />
          </Col>
        </Col>
      </Card>
    </div>
  )
}
